export const PHARMACY_TERMS = 'https://about.curon.co/terms/pharmacy'

export const PRIVACY_POLICY = 'https://micin.jp/privacy/'

export const EXTERNAL_TRANSMISSION = 'https://curon.co/assets/external_transmission.pdf'

export const SECURITY_WHITEPAPER = 'https://id.curon.co/whitepaper.pdf'

export const ONLINE_MEDICAL_PRIVACY_POLICY = 'https://curon.co/static/app/privacy.html'
